import React, { Component } from 'react';
import { connect } from "react-redux";

require('./ModalListItem.scss');

class HoursItem extends Component {
	constructor(props){
		super(props);
		this.state = {
			enabled: this.props.enabled,
			hours: this.props.hours,
		};
	}
	onChangeChecked(){
		this.props.checkboxSwitch();
		this.state.enabled = !this.state.enabled;
	}
	onChangeHours(n){
		n = Number(n);
		if(!(!isNaN(parseFloat(n)) && isFinite(n))){
			return;
		}
		if (n > 24) return;
		if (n % 1 !== 0) {
			//round to nearest .5
			n = (Math.round(n*2)/2).toFixed(1).toString();
		}
		this.props.changeHoursInput(n);
		this.setState({hours: n});
	}

	render() {
		return (
			<div className="row workHoursItem">
				<div className="col-xs-3 enableItem text-center">
					<input type="checkbox" defaultChecked={ this.state.enabled } onChange={this.onChangeChecked.bind(this)} />
				</div>
				<div className={ this.state.enabled ? "col-xs-4 dayItem activeDay" : "col-xs-4 dayItem inactiveDay" } >
					<span>{ this.props.day }</span>
				</div>
				<div className={ this.state.enabled ? "col-xs-4 hourItem activeHour" : "col-xs-4 hourItem inactiveHour" } >
					<input type="number" min="0" max="24" step="0.5" placeholder="8.0" value={ this.state.hours } onChange={(event) => { this.onChangeHours(event.target.value); }} />
				</div>
			</div>
		);
	}
}

export default connect()(HoursItem);



// WEBPACK FOOTER //
// ./app/components/Modals/ModalListItems/HoursItem.jsx